import { Authenticator } from '@aws-amplify/ui-react';
import { 
    AppBar, 
    Toolbar, 
    Typography, 
    Button, 
    Box,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import { AccountCircle, Dashboard, Games, Schedule, Share } from '@mui/icons-material';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminHeader: React.FC = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const location = useLocation();

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const isMenuOpen = Boolean(anchorEl);

    return (
        <AppBar position="static" sx={{ backgroundColor: '#1976d2', marginBottom: 3 }}>
            <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                    <Dashboard sx={{ mr: 1 }} />
                    Famous Initials Admin
                </Typography>
                
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Button 
                        color="inherit" 
                        component={Link} 
                        to="/"
                        startIcon={<Dashboard />}
                        sx={{ 
                            backgroundColor: location.pathname === '/' ? 'rgba(255,255,255,0.1)' : 'transparent'
                        }}
                    >
                        Dashboard
                    </Button>
                    <Button
                        color="inherit"
                        component={Link}
                        to="/manage-games"
                        startIcon={<Games />}
                        sx={{
                            backgroundColor: location.pathname.startsWith('/manage-games') || location.pathname.startsWith('/games') ? 'rgba(255,255,255,0.1)' : 'transparent'
                        }}
                    >
                        Games
                    </Button>
                    <Button
                        color="inherit"
                        component={Link}
                        to="/manageschedule"
                        startIcon={<Schedule />}
                        sx={{
                            backgroundColor: location.pathname === '/manageschedule' ? 'rgba(255,255,255,0.1)' : 'transparent'
                        }}
                    >
                        Schedule
                    </Button>
                    <Button
                        color="inherit"
                        component={Link}
                        to="/socialmedia"
                        startIcon={<Share />}
                        sx={{
                            backgroundColor: location.pathname === '/socialmedia' ? 'rgba(255,255,255,0.1)' : 'transparent'
                        }}
                    >
                        Social Media
                    </Button>

                    <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls="primary-search-account-menu"
                        aria-haspopup="true"
                        onClick={handleProfileMenuOpen}
                        color="inherit"
                    >
                        <AccountCircle />
                    </IconButton>
                </Box>
                
                <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    id="primary-search-account-menu"
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={isMenuOpen}
                    onClose={handleMenuClose}
                >
                    <Authenticator socialProviders={['google']}>
                        {({ signOut, user }) => (
                            <MenuItem onClick={() => { 
                                if (signOut) {
                                    signOut(); 
                                }
                                handleMenuClose(); 
                            }}>
                                Sign Out
                            </MenuItem>
                        )}
                    </Authenticator>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default AdminHeader;